import AddBasketDrawerStageOne from 'components/home/drawers/AddBasketDrawerStageOne'
import AddBasketDrawerStageTwo from 'components/home/drawers/AddBasketDrawerStageTwo'
import React, {useState} from 'react'
import Drawer from 'react-modern-drawer'
import {useSelector} from 'react-redux'

const BasketCardDrawer = ({isOpenDrawer, setIsOpenDrawer, singleDrawerProduct, setApprovalModal ,setSingleDrawerProduct}) => {
    const [productStage, setProductStage] = useState(1)
  const [productCount, setProductCount] = useState(1)
  const { general } = useSelector(state => state)
  const { getAllBasket } = general
  return (
    <Drawer
        open={isOpenDrawer}
        onClose={() => setIsOpenDrawer(!isOpenDrawer)}
        direction='right'
        className='homeAddBasketDrawer'
    >
        {productStage == 1 && <AddBasketDrawerStageOne setSingleDrawerProduct={setSingleDrawerProduct} isOpenDrawer={isOpenDrawer} setProductCount={setProductCount} productCount={productCount} productData={singleDrawerProduct} setIsOpenDrawer={setIsOpenDrawer} setProductStage={setProductStage} />}
        {productStage == 2 && <AddBasketDrawerStageTwo setApprovalModal={setApprovalModal} setSingleDrawerProduct={setSingleDrawerProduct} isOpenDrawer={isOpenDrawer} getAllBasket={getAllBasket} setProductCount={setProductCount} productCount={productCount} setIsOpenDrawer={setIsOpenDrawer} setProductStage={setProductStage} />}
    </Drawer>
  )
}

export default BasketCardDrawer